var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85799 3.63502V0.770403C8.85799 0.130732 9.59439 -0.213807 10.0947 0.144851L10.1804 0.215526L16.4262 6.1102C16.7177 6.3853 16.7442 6.82717 16.5057 7.13263L16.4263 7.21987L10.1804 13.1164C9.7113 13.5594 8.94872 13.275 8.86544 12.6714L8.85799 12.5617V9.68929L8.52379 9.68292C5.75489 9.67486 3.38814 10.7933 1.37124 13.0672C0.854858 13.6494 -0.113761 13.2024 0.0109795 12.4395C0.872629 7.1698 3.76087 4.19268 8.5434 3.6659L8.85799 3.63502Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.aaf8e7afae1a68ab9a2f1c9f595ca9eb.svg";
export { ForwardRef as ReactComponent };